import { FadeIn } from "@/components/common/FadeIn";

const cases = [
  {
    title: "Escalamiento comercial B2B",
    sector: "Servicios profesionales",
    outcome: "+37% en cierre de oportunidades en 6 meses",
    image:
      "https://images.unsplash.com/photo-1758518731457-5ef826b75b3b?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Transformación de procesos core",
    sector: "Industria y operaciones",
    outcome: "-28% en tiempos de ciclo operacional",
    image:
      "https://images.unsplash.com/photo-1574848296471-28f79a036f79?auto=format&fit=crop&w=1400&q=80",
  },
  {
    title: "Modelo de gestión directiva",
    sector: "Empresas de alto crecimiento",
    outcome: "3x mejora en velocidad de decisión",
    image:
      "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1400&q=80",
  },
];

export const CaseStudies = () => {
  return (
    <section id="casos" className="py-20 md:py-28" data-testid="case-studies-section">
      <div className="section-container">
        <FadeIn>
          <p className="text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="case-studies-kicker-text">
            Casos de éxito
          </p>
          <h2 className="mt-3 text-base md:text-lg text-slate-600" data-testid="case-studies-subheading-text">
            Historias donde estrategia y ejecución se transformaron en impacto medible.
          </h2>
        </FadeIn>

        <div
          className="mt-10 flex snap-x snap-mandatory gap-6 overflow-x-auto pb-4"
          data-testid="case-studies-horizontal-strip"
        >
          {cases.map((caseItem, index) => (
            <FadeIn key={caseItem.title} delay={0.08 * (index + 1)} className="min-w-[320px] flex-1 snap-start md:min-w-[420px]">
              <article className="relative h-[420px] overflow-hidden border border-slate-200" data-testid={`case-study-card-${index + 1}`}>
                <img
                  src={caseItem.image}
                  alt={caseItem.title}
                  className="h-full w-full object-cover object-center"
                  data-testid={`case-study-image-${index + 1}`}
                />
                <div
                  className="absolute inset-0 bg-gradient-to-b from-slate-900/15 via-slate-900/30 to-slate-900/90 p-7"
                  data-testid={`case-study-overlay-${index + 1}`}
                >
                  <p className="text-xs uppercase tracking-[0.18em] text-slate-200" data-testid={`case-study-sector-${index + 1}`}>
                    {caseItem.sector}
                  </p>
                  <h3 className="corporate-title-balance mt-3 text-2xl text-white" data-testid={`case-study-title-${index + 1}`}>
                    {caseItem.title}
                  </h3>
                  <p className="mt-3 text-sm text-slate-200" data-testid={`case-study-outcome-${index + 1}`}>
                    {caseItem.outcome}
                  </p>
                </div>
              </article>
            </FadeIn>
          ))}
        </div>
      </div>
    </section>
  );
};
